import React from 'react';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import {HrLine} from "../styledComponent/styledComponents";
import {downloadPlatforms} from "../../utils/data";
import Box from "@mui/material/Box";
import {DialogStyled} from "./modalComponent";
import {ModalIds, useModal} from "../../contexts/ModalContext";
import {useMediaQuery} from "@mui/material";
import {useSendAppLinkOrSmsMutation} from "../../features/apiSlice/installApplication";
import Skeleton from "@mui/material/Skeleton";
import {toast} from 'react-toastify';


const InstallApplicationModal = () => {
    const {handleClose, modalId, modalOption} = useModal()

    const matches = useMediaQuery('(min-width:200px) and (max-width:600px)');

    const [sendSmsLinkRequest, {isLoading, error, isError}] = useSendAppLinkOrSmsMutation()

    const downloadPlatformsPlusMarketNames = downloadPlatforms.map((p, i) => {
        return {
            ...p,
            marketName: modalOption?.data && Object.keys(modalOption?.data)[i]
        }
    })

    const handleSendLink = (marketName) => {
        sendSmsLinkRequest({type: "sms", market: marketName ?? 'google_play'})
            .unwrap()
            .then((response) => toast.success(response.status))
            .catch((error) => toast.error(error?.data?.message))

        handleClose()
    }


    return (
        <DialogStyled open={modalId === ModalIds.INSTALL_APP} onClose={handleClose}
                      width={!matches ? "600px" : "330px"}>
            <Stack direction={'row'}
                   width={"100%"}
                   height={60}
                   justifyContent={"space-between"}
                   px={3}
                   color={"tertiary.main"}
                   alignItems={"center"}>
                <Typography fontSize={16} fontWeight={"bold"}>
                    دانلود از:
                </Typography>
                <IconButton size={'small'} color={"fourth"} onClick={handleClose}>
                    <ClearIcon/>
                </IconButton>
            </Stack>
            <HrLine/>
            <Stack direction={'column'} width={"100%"} justifyContent={"space-between"} px={2}>
                {
                    isLoading ? downloadPlatformsPlusMarketNames.map((p, i) => (
                            <Stack my={1} key={i} px={3}><Skeleton variant="rounded" width={'100%'} height={60}
                                                                   sx={{bgcolor: '#efefef'}}/></Stack>))

                        : (downloadPlatformsPlusMarketNames.map((platform, index) => (
                            <Box px={3} key={platform.id}>
                                <Stack width={"100%"} height={96} justifyContent={"space-between"}
                                       color={"tertiary.main"}
                                       direction={'row'}
                                       alignItems={"center"}>
                                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}
                                           gap={2}>
                                        <Stack direction={"row"} alignItems={"center"} p={0.5} borderRadius={3}
                                               border={"1px solid #D9E2E7"}>
                                            <img src={platform.source} alt={platform.alt} width={34}
                                                 height={32}/>
                                        </Stack>
                                        <Typography fontSize={{xs: 14, sm: 16}}>
                                            {platform.name}
                                        </Typography>
                                    </Stack>
                                    <Typography
                                        sx={{cursor: "pointer"}}
                                        onClick={() => handleSendLink(platform?.marketName)}
                                        fontSize={{xs: 14, sm: 16}}
                                        color={"primary"}
                                        borderBottom={"1px solid #FD6A16"}>
                                        دریافت لینک
                                    </Typography>
                                </Stack>
                                {downloadPlatformsPlusMarketNames.length - 1 > index && <HrLine/>}
                            </Box>
                        )))
                }
            </Stack>
        </DialogStyled>
    );
};

export default InstallApplicationModal;